import { Output, EventEmitter, Input, OnInit, Component } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { OrientationService } from "../../../../../phf.service";

@Component({
    selector: 'orientation-die-window',
    templateUrl: './orientation-die.component.html',
    styleUrls: ['../../part-detail.component.scss']
})

export class OrientationDieDialog implements OnInit {
    orientationDieEditForm: FormGroup;
    part: any;
    public opened: boolean

    @Input()
    set data(editForm: FormGroup) {
        if (editForm) {
            this.part = editForm.value;
        }
    }

    @Output()
    save: EventEmitter<any> = new EventEmitter();
    @Output()
    close: EventEmitter<any> = new EventEmitter();

    constructor(
        private readonly formBuilder: FormBuilder,
        public readonly orientationService: OrientationService
    ) {
        this.orientationService.read();
    }

    ngOnInit() {
        this.orientationDieEditForm = this.formBuilder.group(OrientationDieForm);
        this.orientationDieEditForm.reset(this.part);
    }

    closeWindow() {
        this.close.emit();
        this.opened = false;
    }

    // Builds and passes OrientationNote value to the OrientationDie editForm in PartLoading tab
    onSave() {
        this.save.emit(this.orientationDieEditForm.get('OrientationInDie').value);
    }

    onClicked = (dataItem, orientation) => {
        const orientationDescription = this.orientationService.value.find(x => x.Id === dataItem);
        const description = (orientationDescription ? ` ${orientationDescription.Description}` : '') + ` ${orientation},`;

        if (this.orientationDieEditForm.get("OrientationInDie").value && orientationDescription) {
            const orientationNote = this.orientationDieEditForm.get("OrientationInDie").value.concat(description);
            this.orientationDieEditForm.get("OrientationInDie").setValue(orientationNote);
        } else {
            this.orientationDieEditForm.get("OrientationInDie").setValue((orientationDescription ? orientationDescription.Description : '') + ` ${orientation},`);
        }
    }
}


const OrientationDieForm = {
    OrientationInDie: []
}


